import ChatIcon from './ChatIcon';
import FormIcon from './FormIcon';
import MessengerIcon from './MessengerIcon';
import PhoneIcon from './PhoneIcon';
import ScheduleIcon from './ScheduleIcon';
import VideoIcon from './VideoIcon';
import WhatsappIcon from './WhatsappIcon';

const CommunicationIcons = {
  ChatIcon,
  FormIcon,
  MessengerIcon,
  PhoneIcon,
  ScheduleIcon,
  VideoIcon,
  WhatsappIcon,
};

export default CommunicationIcons;
